 <!-- Start -->
 <p-toast [breakpoints]="{'575px': {width: '100%', right: '0', left: '0', display: 'flex', 'justify-content': 'center', 'align-items': 'center'}}"></p-toast>
 <!-- End -->